<!-- eslint-disable max-len -->
<template>
  <div>
    <report-header
      :download="download"
      :report="report"
      :csv-data="csvData"
    />
    <div id="report">
      <report-result-query :query="query" />
      <v-card
        flat
        class="back"
        :loading="loading"
      >
        <div style="display: flex;align-items: center;justify-content: center;margin: 0 auto;text-align: center;flex-direction: row;">
          <report-result-box
            title="TOTAL DE TÍTULOS"
            :result="result.publicacoes ? result.publicacoes.length.toString() : '0'"
          />
          <report-result-box
            title="TOTAL DE ITENS FÍSICOS"
            :result="result.totalFisico && result.totalFisico ? result.totalFisico.toString() : '0'"
          />
          <report-result-box
            title="TOTAL DE ITENS DIGITAIS"
            :result="result.totalDigital && result.totalDigital ? result.totalDigital.toString() : '0'"
          />
          <report-result-box
            title="TOTAL GERAL DE ITENS"
            :result="(result.totalFisico + result.totalDigital)"
          />
        </div>
      </v-card>
      <div
        v-if="report === 'Relatório Espécie Documental/Tipo de Objeto'"
        style="display: flex;align-items: center;margin: 20px;"
      >
        <table class="tg">
          <tr>
            <th class="tg-0lax">REGISTRO</th>
            <th class="tg-0lax">TÍTULO</th>
            <th class="tg-0lax">LOCALIZAÇÃO</th>
            <th class="tg-0lax">TIPO DE OBJETO/ESPÉCIE DOCUMENTAL</th>
          </tr>
          <tr
            v-for="item in csvData"
            :key="item.id"
          >
            <td class="tg-0lax">{{item.registro}}</td>
            <td class="tg-0lax">{{item.titulo}}</td>
            <td class="tg-0lax">{{item.localizacao}}</td>
            <td class="tg-0lax">{{item.tipoOuEspecie}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import reportHeader from '@/components/report-header.vue';
import reportResultBox from '@/components/report-result-box.vue';
import reportResultQuery from '@/components/report-result-query.vue';
import download from '@/mixins/download';

export default {
  components: {
    reportHeader,
    reportResultBox,
    reportResultQuery,
  },
  mixins: [download],
  data() {
    return {
      report: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate(to);
      vm.report = 'Relatório Espécie Documental/Tipo de Objeto';
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate(to);
    this.report = 'Relatório Espécie Documental/Tipo de Objeto';
    next();
  },
  computed: {
    ...mapGetters('views/reports/documental', [
      'result',
      'query',
      'csvData',
      'loading',
    ]),
  },
  methods: {
    ...mapActions('views/reports/documental', ['afterRouteUpdate']),
  },
};
</script>
<style scoped>
.tg {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.tg td {
  font-size: 14px;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: #eceff0;
}
.tg th {
  font-size: 14px;
  font-weight: normal;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  color: #1e398d;
  border-color: #eceff0;
}
.tg .tg-0lax {
  text-align: left;
  vertical-align: top;
}
.back {
  background-color: #fafafa !important;
}
</style>
